import styled from 'styled-components';

const B = styled.b`
  display: block;
  font-weight: bold;
`;

B.displayName = 'B';

export default B;



// WEBPACK FOOTER //
// ./src/components/B.js